import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-169ab01d"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "unlock-provider-form" };
const _hoisted_2 = { class: "unlock-api" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("legend", { class: "api-key-label" }, "Incolla qui il codice per l'attivazione", -1));
const _hoisted_4 = {
    class: "api-key-input-outer",
    id: "secretDiv"
};
const _hoisted_5 = {
    key: 0,
    id: "successMessage",
    class: "active-label"
};
const _hoisted_6 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_mini_spinner = _resolveComponent("mini-spinner");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("fieldset", null, [
                _hoisted_3,
                _createElementVNode("div", _hoisted_4, [
                    _withDirectives(_createElementVNode("input", {
                        class: "api-key-input",
                        name: "secret",
                        type: "text",
                        placeholder: "Incolla qui il codice per l'attivazione",
                        id: "secret",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.userSecretKey) = $event))
                    }, null, 512), [
                        [_vModelText, _ctx.userSecretKey]
                    ])
                ]),
                (_ctx.done)
                    ? (_openBlock(), _createElementBlock("label", _hoisted_5, "Attivazione completata!"))
                    : (!_ctx.loading && !_ctx.done)
                        ? (_openBlock(), _createElementBlock("input", {
                            key: 1,
                            class: "unlock-now-button",
                            id: "unlockButton",
                            type: "button",
                            value: "OK",
                            title: "Unlock service",
                            alt: "Unlock service",
                            onClick: _cache[1] || (_cache[1] =
                                //@ts-ignore
                                (...args) => (_ctx.activate && _ctx.activate(...args))),
                            disabled: !_ctx.userSecretKey
                        }, null, 8, _hoisted_6))
                        : _createCommentVNode("", true)
            ])
        ]),
        (_ctx.loading)
            ? (_openBlock(), _createBlock(_component_mini_spinner, { key: 0 }))
            : _createCommentVNode("", true)
    ]));
}
